module.exports = __webpack_public_path__ + "static/media/fsc3.f67b44cf.svg";